module.exports = __webpack_public_path__ + "static/img/movement-home-hover.d5d2d21.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/doom-yoga/movement-home-hover.png
// module id = Zp8y
// module chunks = 0